module.exports = __webpack_public_path__ + "img/thumbnail_IndianPeafowl_m_normal.35f1f5c4.png";